<template>
  <div>
    <div class="driver_info">
      <div>
        <b>{{$t('modal.form.totalCount')}}:</b> <span>{{finishOptions.total_products_quantity}}</span>
      </div>
      <div>
        <b>{{$t('modal.form.basic_tara_count')}}:</b> <span>{{finishOptions.empty_tara}}</span>
      </div>
      <div>
        <b>{{$t('modal.form.new_contracts_bottles_quantity')}}:</b> <span>{{finishOptions.new_contracts_bottles_quantity}}</span>
      </div>
      <div>
        <b>{{$t('modal.form.additional_tara_caunt')}}:</b> <span>{{finishOptions.extra_tara_count}}</span>
      </div>
      <div>
        <b>{{$t('modal.form.get_tara_count')}}:</b> <span>{{finishOptions.returned_client_products}}</span>
      </div>
      <div>
        <b>{{$t('modal.form.not_sold_tara_count')}}:</b> <span>{{finishOptions.returned_products_count}}</span>
      </div>
      <div>
        <b>{{$t('data.allSum')}}</b> <span>{{parseInt(finishOptions.money_paid_by_driver) + parseInt(finishOptions.driver_debt)}}</span>
      </div>
      <div>
        <b>{{$t('modal.form.set_driver_monet_real')}}:</b> <span>{{finishOptions.money_paid_by_driver}}</span>
      </div>
      <div :class="finishOptions.driver_debt == 0 ? '' : 'text-danger'">
        <b>{{$t('modal.form.debt_driver_money')}}:</b> <b>{{finishOptions.driver_debt}}</b>
      </div>
    </div>

    <div class="d-flex justify-content-end align-items-center gap-2">
      <b-button
        class=""
        variant="warning"
        @click="onClose"
      >
        {{$t('modal.button.back')}}
      </b-button>

      <b-button
          class=""
          variant="danger"
          :disabled="db"
          @click="handleReject"
      >
        {{$t('modal.button.reject')}}
      </b-button>


      <b-button
          class=""
        variant="success"
          :disabled="db"
        @click="handleAccept"
      >
        {{$t('modal.button.accept')}}
      </b-button>
    </div>
  </div>
</template>

<script>
  import {storeDriverWaterRound} from '../../../../api/endpoints/driverWaterRounds'
  export default {
    name: "DriverWaterRounds-FinishModal",
    props: {
      finishOptions: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        db: false,
      }
    },
    methods: {
      handleAccept() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        storeDriverWaterRound({id: this.finishOptions.id,status: 5}).then( () => {
          this.onClose();
        })
      },
      handleReject() {
        this.db = true;
        setTimeout(() => {
          this.db = false;
        }, 700)
        storeDriverWaterRound({id: this.finishOptions.id, status: 6}).then( () => {
          this.onClose();
        })
      },
      onClose() {
        this.$emit('onClose')
      }
    }
  }
</script>

<style lang="scss">
.driver_info {
  margin-bottom: 15px;
  div {
    font-size: 14px;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba($color: #000, $alpha: 0.2);
  }
}
</style>
